import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/System/WebUI/SuccessBox';
import WebUITable from 'components/Web_User_Interface/1080p_Series/System/WebUI/webUITable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  WebUITable,
  BreadCrumbs,
  SEOHelmet,
  React
};